import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Tabs, Tab } from '@mui/material';
import { useSetAtom } from 'jotai';
import { endedCallDataAtom, openSnackbarAdviseAtom } from '../../Atoms';
import useAPI from '../../api';
import CallResultBox from '../../Pages/CustomerPage/CallSection/ResultBox';
import { FullSizeColumn } from '../FlexBox';
import Dialog from '../Dialog';

const OutcomeDialog = function OutcomeDialog({
  open,
  onClose,
  callId,
  selectedCustomer,
  isOperator = false,
  campaignId,
}) {
  const intl = useIntl();
  const API = useAPI();

  const openSnackbar = useSetAtom(openSnackbarAdviseAtom);
  const setEndedCallData = useSetAtom(endedCallDataAtom);
  const [answered, setAnswered] = useState('ANSWERED');

  const onChangeAnswered = (event, newValue) => {
    setAnswered(newValue);
  };

  const handleEndCall = (callResult) => {
    const payload = {
      ...selectedCustomer,
      callOutcome: {
        ...callResult,
        callId,
      },
    };

    API.endCall(
      payload?.callOutcome?.callId,
      payload,
      false,
      (result) => {
        openSnackbar({
          message: intl.messages.OUTCOME_SET_SUCCESS,
          severity: 'success',
        });
        setEndedCallData(result);
      },
      () => {
        openSnackbar({
          message: intl.messages.OUTCOME_SET_ERROR,
          severity: 'error',
        });
      }
    );
  };

  return (
    <Dialog
      id="outcome-dialog"
      open={open}
      onClose={onClose}
      title={intl.messages.OUTCOME}
      width="sm"
      fullWidth
    >
      <FullSizeColumn>
        <Tabs variant="fullWidth" value={answered} onChange={onChangeAnswered}>
          <Tab label={intl.messages.ANSWERED} value={'ANSWERED'} />
          <Tab label={intl.messages.NOT_ANSWERED} value={'NOT_ANSWERED'} />
        </Tabs>
        <CallResultBox
          answered={answered === 'ANSWERED'}
          handleEndCall={handleEndCall}
          isOperator={isOperator}
          campaignId={campaignId}
        />
      </FullSizeColumn>
    </Dialog>
  );
};
export default OutcomeDialog;
